<template>
  <div class="search-form">
    <div class="d-flex">
      <div style="width:350px;" class="mb-2">
        <b-input-group size="sm">
          <b-form-input
            @keyup.enter="query"
            type="search"
            v-model.trim="form.keyword"
            placeholder="调度订单/订单/运单/(ERP/WMS单号)/销售订单号..."
          />
          <b-input-group-append>
            <b-button-group>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  高级搜索
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-button-group>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="mb-2">
        <b-input-group size="sm">
          <b-button
            size="sm"
            v-allow="'actExport'"
            variant="outline-success"
            class="ml-2"
            @click="$emit('batchExport')"
          >
            <i class="el-icon-folder-opened"></i>
            批量导出
          </b-button>
        </b-input-group>
      </div>
    </div>
    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="订单编号">
              <el-input
                v-model="form.orderNo"
                placeholder="请输入订单编号"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="调度订单编号">
              <el-input
                v-model="form.dispatchOrderNo"
                placeholder="请输入调度订单编号"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="运单编号">
              <el-input
                v-model="form.waybillNo"
                placeholder="请输入运单编号"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="ERP/WMS单号">
              <el-input
                v-model="form.bizBillNo"
                placeholder="请输入ERP/WMS单号"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="销售订单号">
              <el-input
                v-model="form.orderSoNo"
                placeholder="请输入销售订单号"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单类型">
              <dict-select
                filterable
                clearable
                v-model="form.orderType"
                placeholder="请选择订单类型"
                default
                :body="orderTypeDictParams"
              >
              </dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="订单创建起始时间">
              <el-date-picker
                style="width:100%"
                v-model="form.creatBeginDate"
                :picker-options="dateStartPicker"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择创建起始时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单创建截至时间">
              <el-date-picker
                style="width:100%"
                v-model="form.creatEndDate"
                :picker-options="dateEndPicker"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择创建截至时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="承运商名称">
              <dict-select
                style="width:100%"
                v-model="form.carrierCode"
                clearable
                filterable
                url="/master/carrier/info/select"
                placeholder="请选择承运商"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="异常登记时间">
              <el-date-picker
                style="width:100%"
                v-model="form.execBeginDate"
                :picker-options="execDateStartPicker"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择异常起始时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="至">
              <el-date-picker
                style="width:100%"
                v-model="form.execEndDate"
                :picker-options="exceDateEndPicker"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择异常结束时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户名称">
              <dict-select
                style="width:100%"
                clearable
                filterable
                v-model="form.custCode"
                url="/master/customer/info/select"
                placeholder="请选择客户"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="运输状态">
              <el-select
                v-model="form.bizStatusList"
                placeholder="请选择运输状态"
                multiple
                filterable
                clearable
                style="width:100%"
              >
                <el-option value="1" label="待提货"></el-option>
                <el-option value="2" label="待送达"></el-option>
                <el-option value="3" label="待回单"></el-option>
                <el-option value="4" label="回单待审核"></el-option>
                <el-option value="5" label="回单已拒绝"></el-option>
                <el-option value="6" label="待完成"></el-option>
                <el-option value="8" label="已完成"></el-option>
                <el-option value="9" label="拒收"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          取消查询
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          重置条件
        </el-button>
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyword: '',
  bizStatusList: [],
  isAbnormal: 'Y',
}
export default {
  data() {
    return {
      //订单类型下拉请求参数
      orderTypeDictParams: { type: 'orderType' },
      form: { ...initForm },
      advqueryDialogVisible: false,
      execDateStartPicker: this.execDateEnd(),
      exceDateEndPicker: this.execDateStart(),
      dateStartPicker: this.dateEnd(),
      dateEndPicker: this.dateStart(),
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 跳转到订单创建页面
    jumpCreatePage() {
      this.$router.push({ name: 'carriage-builderOrder' })
    },
    batchSumit() {
      this.$emit('batchSumit')
    },
    execDateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.execEndDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.execEndDate).getTime() < time.getTime()
          }
        },
      }
    },
    execDateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.execBeginDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.execBeginDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    //时间限制
    dateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.creatEndDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.creatEndDate).getTime() < time.getTime()
          }
        },
      }
    },
    dateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.creatBeginDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.creatBeginDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
